import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEventListener } from '@packages/shared';
import { Icon } from '@drdropin-tech/theseus';
import classNames from 'classnames';
import Fuse from 'fuse.js';
import { useState } from 'react';
import { getCountryCallingCode } from 'react-phone-number-input';
import countryLabelsList from './countryTranslations.json';
const CountrySelect = ({ name, options, selected, onChange, i18nFunction, ariaLabel, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState();
    const countryLabels = countryLabelsList;
    const getCountryLabelsList = (country) => Object.keys(countryLabels).reduce((acc, label) => {
        if (label === country) {
            return { label: countryLabels[label], value: label };
        }
        return acc;
    }, {});
    const countries = options.map((country) => {
        const callingCode = getCountryCallingCode(country);
        const countryLabel = getCountryLabelsList(country);
        return {
            value: country,
            countryLabel: countryLabel?.label,
            callingCode,
        };
    });
    const [selectedCountryCallingCode, setSelectedCountryCallingCode] = useState(() => {
        if (selected) {
            return countries.find((country) => country.value === selected)
                ?.callingCode;
        }
        return '';
    });
    const handleChange = (country) => {
        setSelectedCountryCallingCode(country.callingCode);
        onChange(country.value);
    };
    const sortedCountries = countries
        .sort((ca, cb) => ca.countryLabel?.localeCompare(cb.countryLabel))
        .filter((country) => !!country.countryLabel);
    return (_jsxs("div", { className: "relative text-black transition-all", children: [_jsxs("button", { id: name, type: "button", className: "w-23 input border-accent focus-input flex items-center rounded-lg border-2 pl-4 pr-8", onClick: (e) => {
                    e.preventDefault();
                    setIsOpen(!isOpen);
                }, "aria-label": ariaLabel, "aria-haspopup": "listbox", "aria-expanded": isOpen, children: [_jsxs("span", { className: "font-normal", children: ["+", selectedCountryCallingCode] }), _jsx("div", { className: classNames({ 'rotate-180': isOpen }, 'absolute inset-y-0 right-1 flex items-center transition-all'), children: _jsx(Icon, { name: "ChevronDown", iconSize: "sm", "aria-hidden": "true" }) })] }), isOpen ? (_jsx(DropDown, { countries: sortedCountries, onInputChange: setInputValue, onChange: handleChange, selected: selected, inputValue: inputValue, closeList: () => setIsOpen(false), i18nFunction: i18nFunction })) : null] }));
};
const DropDown = ({ countries, selected, inputValue, onChange, onInputChange, closeList, i18nFunction, }) => {
    const fuse = new Fuse(countries, {
        keys: ['countryLabel', 'value', 'callingCode'],
    });
    const t = i18nFunction;
    const result = !!inputValue
        ? fuse.search(inputValue).map((val) => val.item)
        : countries;
    const handleChange = (country) => {
        onChange(country);
        closeList();
    };
    const handleInputChange = (e) => {
        onInputChange(e.currentTarget.value);
    };
    useEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeList();
        }
    });
    return (_jsxs("div", { className: classNames('md:max-h-100 divide-primary/20 absolute -bottom-2 left-0 z-10 flex max-h-80 min-w-[280x] translate-y-full flex-col divide-y-2 overflow-scroll rounded-lg bg-white shadow-md transition-all md:min-w-[400px]'), children: [_jsx("div", { className: "p-4", children: _jsx("input", { type: "search", placeholder: t('steps.personal_details.input.placeholder.country_select'), onChange: handleInputChange, className: "input border-accent input-sm focus:ring-accent w-full rounded-md border-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white" }) }), _jsx("div", { children: result.map((country) => (_jsxs("button", { className: classNames({ 'bg-accent': selected === country.value }, 'hover:bg-accent focus:outline-accent flex w-full cursor-pointer justify-between px-8 py-2 focus:outline-2'), onClick: () => handleChange(country), children: [_jsx("span", { children: country.countryLabel }), _jsxs("span", { className: "opacity-70", children: ["+", country.callingCode] })] }, country.value))) })] }));
};
export default CountrySelect;
